import { ICreateWithdrawalFormValues } from '../../layouts/employee/CreateWithdrawalForm'
import { IWithdrawalsHistoryFilterValues, withdrawalsHistoryFilterDefaultState } from '../../pages/withdrawals/dashboard/WithdrawalsDashboardHistory'
import { ILoadingAndFailure, IPaginationResponse, IWithdrawal } from '../../types/interfaces'
import { getReq, postReq } from '../../utils/requests'
import { ThunkResult } from '../index'
import { mapWithdrawalsLoadListByUserRequest, mapWithdrawalsLoadListByUserResponse } from './withdrawalsHelpers'
import { WITHDRAWALS_CREATE, WITHDRAWALS_LOAD_LIST_BY_USER } from './withdrawalsTypes'

/* Load list by user */

export interface IWithdrawalsLoadListByUserPayload extends ILoadingAndFailure {
	records?: IWithdrawal[]
	pagination?: IPaginationResponse
}

interface IWithdrawalsLoadListByUserAction {
	type: WITHDRAWALS_LOAD_LIST_BY_USER
	payload: IWithdrawalsLoadListByUserPayload
}

export const withdrawalsLoadListByUser =
	(id: number, filter: IWithdrawalsHistoryFilterValues = withdrawalsHistoryFilterDefaultState): ThunkResult<void> =>
	async (dispatch) => {
		dispatch({ type: WITHDRAWALS_LOAD_LIST_BY_USER.START })
		try {
			const { data } = await getReq(`/api/v1/users/{userID}/withdrawals/`, { userID: id, ...mapWithdrawalsLoadListByUserRequest(filter) })
			dispatch({ type: WITHDRAWALS_LOAD_LIST_BY_USER.DONE, payload: mapWithdrawalsLoadListByUserResponse(data) })
		} catch (error) {
			dispatch({ type: WITHDRAWALS_LOAD_LIST_BY_USER.FAIL })
		}
	}

/* Create */

export const withdrawalsCreate =
	(id: number, values: ICreateWithdrawalFormValues, onSuccess: () => void): ThunkResult<void> =>
	async (dispatch) => {
		dispatch({ type: WITHDRAWALS_CREATE.START })
		try {
			await postReq('/api/v1/users/{userID}/withdrawals/', { userID: id }, { amount: values.amount }, {}, false)
			dispatch({ type: WITHDRAWALS_CREATE.DONE })
			onSuccess()
		} catch (error) {
			dispatch({ type: WITHDRAWALS_CREATE.FAIL })
		}
	}

/* Actions */

export type IWithdrawalsAction = IWithdrawalsLoadListByUserAction
